<template>
    <div>
        <div class="container-fluid">
            <!-- Header -->
            <div class="d-flex align-items-center justify-content-between pt-5 mb-4 flex-wrap gap-3">
                <div class="d-block">
                    <div class="h1-lg display-tektur m-0">Daftar Kode Jurusan</div>
                    <div class="text-muted mt-2">
                        Cari jurusan, lalu salin kodenya ke kolom <strong>Kode Jurusan</strong> pada file import alumni.
                    </div>
                </div>
                <button class="btn btn-outline-secondary" @click="goBack()">
                    <i class="fa-solid fa-arrow-left fa-lg me-2"></i> Kembali
                </button>
            </div>
        </div>

        <!-- Search & Filter -->
        <div class="card rounded-0 m-0 bg-card-trans-3">
            <div class="card-header">
                <div class="input-group input-group-flush input-group-merge input-group-reverse">
                    <input
                        class="form-control list-search"
                        type="search"
                        placeholder="Ketik nama jurusan, contoh: kedokteran"
                        v-model="keywords"
                        @input="onKeywordsInput"
                        @keyup.enter="search"
                    >
                    <span class="input-group-text">
                        <i class="fa-solid fa-search"></i>
                    </span>
                </div>
                <div class="d-flex align-items-center flex-shrink-0">
                    <div class="d-block me-3 text-muted text-nowrap">Universitas:</div>
                    <div class="d-block university-filter" :title="selectedUniversity ? selectedUniversity.name : ''">
                        <div class="form-select-wrapper">
                            <v-select
                                :options="dataUniversity"
                                label="name"
                                v-model="selectedUniversity"
                                placeholder="Semua Universitas"
                                append-to-body
                                @input="setUniversity"
                            >
                                <template #no-options>Universitas tidak ditemukan.</template>
                            </v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Loading -->
        <div v-if="dataFetch" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-muted"><i class="fa-solid fa-spin fa-spinner fa-lg"></i></div>
                        <div class="d-block text-sm text-muted">Loading...</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Data -->
        <div v-if="!dataFetch && dataList.length > 0" class="card rounded-0 m-0 bg-card-trans-3">
            <div class="table-responsive" style="overflow-y:auto; max-height:72.9vh;">
                <table class="table table-sm table-hover card-table th-sticky">
                    <thead>
                        <tr>
                            <th class="text-center" style="width:5%;">No</th>
                            <th style="width:20%;">Kode Jurusan</th>
                            <th>Jurusan</th>
                            <th>Jenjang</th>
                            <th>Universitas</th>
                        </tr>
                    </thead>
                    <tbody class="list fs-base">
                        <tr v-for="(item, index) in dataList" :key="item.id">
                            <td class="text-center">
                                {{ (index + 1) + (pagination.current_page - 1) * pagination.limit }}
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <span class="badge border font-monospace fs-6 me-2">{{ item.major_code }}</span>
                                    <button
                                        type="button"
                                        class="btn btn-sm"
                                        :class="copiedId === item.id ? 'btn-success' : 'btn-outline-secondary'"
                                        :title="'Salin kode ' + item.major_code"
                                        @click="copyCode(item)"
                                    >
                                        <i class="fa-solid me-1" :class="copiedId === item.id ? 'fa-check' : 'fa-copy'"></i>
                                        {{ copiedId === item.id ? 'Tersalin' : 'Salin' }}
                                    </button>
                                </div>
                            </td>
                            <td class="font-bold">{{ item.name }}</td>
                            <td>{{ item.education_level }}</td>
                            <td>{{ item.university_name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div aria-label="navigation" class="card-footer d-flex justify-content-between">
                <ul class="list-pagination-prev pagination pagination-tabs card-pagination">
                    <li class="page-item">
                        <a class="page-link ps-0 pe-4 border-end border-c-1" :class="pagination.current_page <= 1 ? 'disabled':''" href="javascript:void(0)" @click="pagination_handle('prev')">
                            <i class="fa-solid fa-angle-left me-3"></i>Sebelumnya
                        </a>
                    </li>
                </ul>

                <v-pagination v-model="pagination.current_page" :page-count="pagination.total_pages" :classes="pagination.style" :labels="pagination.anchor_text" @change="getData()"></v-pagination>

                <ul class="list-pagination-next pagination pagination-tabs card-pagination">
                    <li class="page-item">
                        <a class="page-link ps-4 pe-0 border-start border-c-1" :class="pagination.current_page >= pagination.total_pages ? 'disabled':''" href="javascript:void(0)" @click="pagination_handle('next')">
                            Selanjutnya<i class="fa-solid fa-angle-right ms-3"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Empty -->
        <div v-if="!dataFetch && emptyState" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                        <div class="d-block text-sm text-muted">Jurusan tidak ditemukan. Coba kata kunci lain atau ganti filter universitas.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vPagination from 'vue-plain-pagination'

export default {
    name: 'MajorCodeReference',
    metaInfo: {
        title: 'Daftar Kode Jurusan',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    components: {
        vPagination
    },
    data() {
        return {
            emptyState      : false,
            dataFetch       : false,
            dataList        : [],
            dataUniversity  : [],
            keywords        : '',
            university_id   : '',
            selectedUniversity : null,
            copiedId       : null,
            searchTimer     : null,
            copiedTimer     : null,
            requestId       : 0,
            pagination: {
                current_page    : 1,
                total_pages     : 0,
                limit           : 50,
                style: {
                    ul: 'list-pagination pagination pagination-tabs card-pagination',
                    li: 'page-item',
                    a: 'page',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                anchor_text: {
                    first: '',
                    prev: '',
                    next: '',
                    last: ''
                }
            }
        }
    },
    created() {
        this.getData();
        this.getUniversity();
    },
    beforeDestroy() {
        clearTimeout(this.searchTimer);
        clearTimeout(this.copiedTimer);
    },
    methods: {
        getData() {
            // Ignore responses from older requests so fast typing never shows stale results.
            const requestId = ++this.requestId;
            this.dataFetch  = true;

            this.$http.get(process.env.VUE_APP_APIHOST + 'major/list', {
                params: {
                    keywords        : this.keywords.trim().toLowerCase(),
                    page            : this.pagination.current_page,
                    limit           : this.pagination.limit,
                    university_id   : this.university_id
                }
            }).then(res => {
                if (requestId !== this.requestId) return;

                this.dataList               = res.data.data || [];
                this.pagination.total_pages = res.data.total_page || 0;
                this.emptyState             = this.dataList.length < 1;
                this.dataFetch              = false;
            }).catch(error => {
                if (requestId !== this.requestId) return;

                this.dataList   = [];
                this.emptyState = true;
                this.dataFetch  = false;
                console.log(error);
            });
        },
        getUniversity() {
            this.$http.get(process.env.VUE_APP_APIHOST + 'university/list', {
                params: { limit: 1000 }
            }).then(res => {
                this.dataUniversity = res.data.data || [];
            });
        },
        setUniversity(university) {
            this.university_id = university ? university.id : '';
            this.search();
        },
        search() {
            clearTimeout(this.searchTimer);
            this.pagination.current_page = 1;
            this.getData();
        },
        onKeywordsInput() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(this.search, 400);
        },
        pagination_handle(params) {
            if (params == 'next' && this.pagination.current_page < this.pagination.total_pages) {
                this.pagination.current_page++;
                this.getData();
            }

            if (params == 'prev' && this.pagination.current_page > 1) {
                this.pagination.current_page--;
                this.getData();
            }
        },
        copyCode(item) {
            const code = String(item.major_code);
            const done = () => {
                this.copiedId = item.id;
                clearTimeout(this.copiedTimer);
                this.copiedTimer = setTimeout(() => { this.copiedId = null; }, 1500);
            };

            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(code).then(done).catch(() => this.copyFallback(code, done));
            } else {
                this.copyFallback(code, done);
            }
        },
        copyFallback(code, done) {
            const textarea = document.createElement('textarea');
            textarea.value = code;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                done();
            } catch (e) {
                console.log(e);
            }
            document.body.removeChild(textarea);
        },
        goBack() {
            // A new tab (opened from the import page) has no history, so go to the alumni import page.
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push({ name: 'import_users', params: { type: 'alumni' } });
            }
        }
    }
}
</script>

<style scoped>
.university-filter {
    width: 360px;
}

/* Keep the selected university on one line; long names end with "…". */
.university-filter ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
    min-width: 0;
    overflow: hidden;
}

.university-filter ::v-deep .vs__selected {
    display: block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 26px;
}

.university-filter ::v-deep .vs--open .vs__selected {
    opacity: .5;
}

.university-filter ::v-deep .vs__actions {
    flex-shrink: 0;
    gap: 6px;
}
</style>
